import React from "react";
import { CpSelect } from "../cp-select/cp-select.component";
import {
  array,
  bool,
  func,
  oneOf,
  oneOfType,
  string,
  object,
} from "prop-types";
import { defaultSearchFilter, filterAlpha } from "../cp-select/common/utils";
import styles from "./../cp-select/cp-select.styles.scss";
import { Scoped } from "kremling";

export function CpSelectMultiPills(props) {
  const {
    appendTo,
    autoFocus,
    className,
    data,
    disabled,
    isGroupData,
    groupType,
    loading,
    onBlur,
    onChange,
    onClose,
    onOpen,
    teamMember,
    placeholder,
    preventKeyOpen,
    preventOutsideClickUntilClosed,
    renderFooter,
    renderPill,
    searchFilter,
    searchOnChange,
    searchValue,
    clearOnSelect,
    stopPropagation,
    transformData,
    triggerRef,
    value,
    contentWidth = "block",
    error,
    renderEmptyState,
    emptyStateAction,
  } = props;
  return (
    <Scoped css={styles}>
      <CpSelect
        appendTo={appendTo}
        className={className}
        contentWidth={contentWidth}
        data={data}
        disabled={disabled}
        insertDone
        isGroupData={isGroupData}
        groupType={groupType}
        loading={loading}
        onChange={onChange}
        onClose={onClose}
        onOpen={onOpen}
        preventKeyOpen={preventKeyOpen}
        preventOutsideClickUntilClosed={preventOutsideClickUntilClosed}
        renderFooter={renderFooter || CpSelect.Footer}
        renderGroup={CpSelect.Group}
        renderItem={CpSelect.ItemMulti}
        renderEmptyState={renderEmptyState}
        emptyStateAction={emptyStateAction}
        renderTrigger={(triggerProps) => (
          <CpSelect.TriggerPills
            autoFocus={autoFocus}
            onBlur={onBlur}
            teamMember={teamMember}
            renderPill={renderPill || ((val) => val.name)}
            placeholder={placeholder}
            error={error}
            {...triggerProps}
          />
        )}
        searchFilter={defaultSearchFilter(searchFilter, searchValue)}
        searchOnChange={searchOnChange}
        searchValue={searchValue}
        clearOnSelect={clearOnSelect}
        stopPropagation={stopPropagation}
        transformData={transformData}
        triggerRef={triggerRef}
        triggerIsBlock
        value={value}
      />
      {typeof error === "string" && (
        <div className="cp-select--error-text">{error}</div>
      )}
    </Scoped>
  );
}

CpSelectMultiPills.propTypes = {
  appendTo: oneOfType([object, oneOf(["parent"])]),
  autoFocus: bool,
  preventOutsideClickUntilClosed: bool,

  className: oneOfType([string, object]),
  data: array,
  disabled: bool,
  filter: func,
  isGroupData: bool,
  groupType: oneOf(["header", "border"]),
  loading: bool,
  onBlur: func,
  onChange: func.isRequired,
  onClose: func,
  onOpen: func,
  placeholder: string,
  preventKeyOpen: bool,
  renderFooter: func,
  renderPill: func,
  searchFilter: oneOfType([func, bool]),
  searchOnChange: func.isRequired,
  searchValue: string.isRequired,
  stopPropagation: bool,
  transformData: func,
  teamMember: bool,
  value: array.isRequired,
  error: oneOfType([bool, string]),

  renderEmptyState: func,
  emptyStateAction: func,
};

CpSelectMultiPills.filterAlpha = filterAlpha;
